import { GlowShadow } from '../../../../Components/GlowShadow'
import * as S from './styles'

export const HeroSection = ({
  logo,
  title,
  text,
  colorBtn,
  img,
  url
}) => {
  return (
    <S.Wrapper>

      <S.ColBox>
        <S.LeftCol>
          <img src={logo} alt="logo" />
          <h2>
            {title}
          </h2>
          <p>
            {text}
          </p>

          <button
            onClick={() => window.open(url, '_blank')}
            style={{
              backgroundColor: `var(${colorBtn})`
            }}
          >
            Acesse o Site Oficial
          </button>
        </S.LeftCol>

        <S.RightCol>
          <img src={img} alt="" />
        </S.RightCol>
      </S.ColBox>

      <GlowShadow />

    </S.Wrapper>
  )
}
